var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOramentos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33333H11.6667V10H2.5V8.33333ZM2.5 6.66667H11.6667V5H2.5V6.66667ZM2.5 13.3333H8.33333V11.6667H2.5V13.3333ZM15.0083 10.725L15.6 10.1333C15.925 9.80833 16.45 9.80833 16.775 10.1333L17.3667 10.725C17.6917 11.05 17.6917 11.575 17.3667 11.9L16.775 12.4917L15.0083 10.725ZM14.4167 11.3167L10 15.7333V17.5H11.7667L16.1833 13.0833L14.4167 11.3167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOramentos);
export default __webpack_public_path__ + "static/media/Orçamentos.f121d9385f50696aad6c89953102f002.svg";
export { ForwardRef as ReactComponent };